import moment from 'moment-timezone'
export const BRAZIL_TIMEZONE = 'America/Sao_Paulo'

export const getLocaleMoment = (locale: string = 'en') => {
  moment.locale(locale)
  return moment
}

export const toDayStringInBrazil = (date: Date | string, format: string = 'YYYY-MM-DD', locale?: string): string => {
  const localMoment = getLocaleMoment(locale)
  return localMoment.tz(date, BRAZIL_TIMEZONE).format(format)
}

export const formatDateTime = (date: Date | string, separator?: string) => {
  const format = separator ? `DD/MM/YYYY [${separator}] HH:mm` : 'DD/MM/YYYY - HH:mm'

  return moment.tz(date, BRAZIL_TIMEZONE).format(format)
}

export const formatDate = (date: Date | string, separator?: string) => {
  const format = separator ? `DD/MM/YYYY [${separator}]` : 'DD/MM/YYYY'

  return moment.tz(date, BRAZIL_TIMEZONE).format(format)
}
